<template>
  <SafeVerifyModal v-model="modalVis.loginPassVerify" :smstype="4" @on-ok="confirmHandle"></SafeVerifyModal>
</template>

<script>
import SafeVerifyModal from '@/views/personal/Modal/SafeVerifyModal'
import { ajaxTry, ajaxAlert, updateUserInfo } from '@/utils'
import { ajax_modifyLoginPassword } from '@/api/personal'

export default {
  name: 'LoginPassVerifyModal',
  inject: {
    modalComp: 'modalComp',
    modalVis: 'modalVis'
  },
  data () {
    return { password: '' }
  },
  async mounted () {
    this.password = await this.$receiver('dataOnce-LoginPassModal-LoginPassVerifyModal')
  },
  components: {
    SafeVerifyModal
  },
  methods: {
    async confirmHandle (code) {
      let ajaxParam = {
        oldPassword: '',
        newPassword: this.password,
        smsCode: code.phone,
        emailCode: code.email,
        googleCode: code.google,
        encryptionProps: ['oldPassword', 'newPassword']
      }
      this.$sender('modify-Public-SafeVerifyModal', 'btnLoading.confirm', true)
      // 开始发送修改请求
      let [flag, res, okPromise] = await ajaxTry(ajax_modifyLoginPassword(ajaxParam)).then(ajaxAlert)
      this.$sender('modify-Public-SafeVerifyModal', 'btnLoading.confirm', false)
      // 修改成功之后关闭验证框
      if (flag) {
        this.modalVis.loginPassVerify = false
        okPromise.then(() => {
          // 用户点击确认之后再更新用户数据
          updateUserInfo([flag, res])
        })
      }

    }
  }
}
</script>

